// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2PWVs","rightAdornment":"Header_rightAdornment__3qvTi"};